// extracted by mini-css-extract-plugin
module.exports = {"noCertification":"styles_noCertification__2sF3i","title":"styles_title__2Y4qy","info":"styles_info__3bZ5z"};